import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { faXTwitter, faFacebook, faLinkedin, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { EffectCreative } from 'swiper/modules';
import './privacy-policy.css';
import { faPhone, faHome } from '@fortawesome/free-solid-svg-icons';
import { faLock, faFileSignature, faFileContract, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { NavLink } from "react-router-dom";

const PrivacyPolicy = () => {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [activeTab, setActiveTab] = useState('Empower');
    const [openBioIndex, setOpenBioIndex] = useState(null);
    const [selectedMember, setSelectedMember] = useState(null);
    const [openIndex, setOpenIndex] = useState(null);
    const [directors, setDirectors] = useState([]);
    const [showAll, setShowAll] = useState(false);
    const closeBio = () => {
      setSelectedMember(null);
    };  
 
  
const toggleBio = (index) => {
  setOpenBioIndex(prevIndex => (prevIndex === index ? null : index));
};

  const toggleDropdown = (index) => {
    setOpenDropdownIndex(openDropdownIndex === index ? null : index);
  };
    const handleBioClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  
  const navItems = [

  { title: 'आम्ही कोण आहोत?', path: '/leadership' },
   { title: 'बातम्या आणि ब्लॉग', path: '/news' },
  { title: 'संपर्क करा', path: '/contact' },
];

  return (
    <>
  
         {/* Header */}

         {/* Header */}
               <header className="header">
                             <div className="nav-container">
                               <div className="logo">
                                 <Link to="/">
                                   <img src="web.png" alt="PIR Logo" />
                                 </Link>
                               </div>
                           
                               {/* Desktop Nav */}
                                  <nav className="nav-links">
                                                                                {navItems.map((item, index) => (
                                                                                  <div key={index} className="nav-item">
                                                                                    <NavLink
                                                                                      to={item.path}
                                                                                      className={({ isActive }) =>
                                                                                        isActive ? "nav-button active" : "nav-button"
                                                                                      }
                                                                                    >
                                                                                      {item.title}
                                                                                    </NavLink>
                                                                                  </div>
                                                                                ))}
                                                                              </nav>
                               
                           
                               {/* Search + Title */}
                               <div className="search-language" style={{ position: "relative" }}>
                                 <div
                                   style={{
                                     position: "absolute",
                                     top: "-19px",
                                     left: "16px",
                                     fontSize: "22px",
                                     color: "#FF6F00",
                                     fontFamily: "Mukta, sans-serif",
                                     whiteSpace: "nowrap",
                                     zIndex: 10,
                                     pointerEvents: "none",
                                   }}
                                 >
                                   <span className="lokadhikar-title">महाराष्ट्र लोकाधिकार समिती</span>
                                 </div>
                           
                                 <div className="pir-search-wrapper">{/* Search Bar */}</div>
                               </div>
                           
                               {/* Hamburger Toggle */}
                               <button
                                 className="mobile-toggle"
                                 onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
                               >
                                 ☰
                               </button>
                             </div>
                           
                             {/* Mobile Menu */}
                             {isMobileMenuOpen && (
                               <div className={`mobile-menu ${isMobileMenuOpen ? "active" : ""}`}>
                             {navItems.map((item, index) => (
                               <Link
                                 key={index}
                                 className="mobile-link"
                                 to={item.path}
                                 onClick={() => setMobileMenuOpen(false)}
                               >
                                 {item.title}
                               </Link>
                             ))}
                           </div>
                             )}
                           </header>
        
   <div className="privacy-policy-container">
    <h1>🔒 गोपनीयता धोरण (Privacy Policy)</h1>
  <h2>1. प्रस्तावना</h2>
  <p>
    महाराष्ट्र लोकाधिकार समिती (“संघटना”, “आम्ही”, “आमचे”) lokadhikar.in (“वेबसाइट/प्लॅटफॉर्म”) वर आपल्या वैयक्तिक माहितीचे संरक्षण करण्यास वचनबद्ध आहे.
    हे धोरण Digital Personal Data Protection Act, 2023 (DPDP Act) आणि त्याअंतर्गत येणाऱ्या नियमांच्या चौकटीत तयार केलेले आहे. या कायद्यानुसार तुम्ही
    “Data Principal” आणि आम्ही “Data Fiduciary” म्हणून कार्य करतो.
  </p>

  <h2>2. लागू क्षेत्र</h2>
  <p>
    हे गोपनीयता धोरण वेबसाइट, आमचे ऑनलाइन फॉर्म, नोंदणी/सदस्यत्व प्रक्रिया, ईमेल मोहिमा, सोशल मीडिया एकत्रीकरण, इव्हेंट/आंदोलन नोंदणी, देणग्या
    (असल्यास) आणि भविष्यातील मोबाइल/वेब अॅप्सवर लागू आहे. DPDP Act अंतर्गत डिजिटल स्वरूपातील किंवा नंतर डिजिटाईज केलेल्या वैयक्तिक माहितीवर हे
    धोरण लागू राहते.
  </p>

  <h2>3. आम्ही कोणती माहिती गोळा करतो</h2>
  <ul>
    <li>ओळख माहिती: नाव, वय/जन्मतारीख, लिंग, छायाचित्र.</li>
    <li>संपर्क माहिती: मोबाईल क्रमांक, ईमेल, पत्ता, पिनकोड.</li>
    <li>व्यावसायिक/संघटनात्मक माहिती: व्यवसाय, उद्योग/व्यवसाय प्रकार, संघटनेतील भूमिका.</li>
    <li>व्यवहार/देणगी माहिती (असल्यास): पेमेंट मोड, रक्कम, ट्रान्झॅक्शन आयडी (कार्ड/UPI तपशील सामान्यतः पेमेंट गेटवे कडे राहतात).</li>
    <li>तक्रार/अर्ज माहिती: कर्ज/बँक/फायनान्स संबंधित तपशील (तुमच्या संमतीने).</li>
    <li>तांत्रिक माहिती: IP address, browser/user agent, cookies, लॉग फाइल्स, analytics डेटा.</li>
    <li>सोशल मीडिया प्रोफाइल लिंक्स (तुम्ही दिल्यास).</li>
    <li>कायद्याने आवश्यक असेल तर ओळख पडताळणीसाठी दस्तऐवज (उदा. ओळखपत्र).</li>
  </ul>

  <h2>4. आम्ही माहिती का व कशी वापरतो (Purpose &amp; Legal Basis)</h2>
  <p>
    • संविधानिक/कायदेशीर हक्कांसाठी सहकार्य व वकिली करणे, तक्रारी हाताळणे, समुपदेशन/मार्गदर्शन देणे.<br />
    • संघटनेतील नोंदणी, सभासदत्व व्यवस्थापन, कार्यक्रम/आंदोलन/मेळावे व्यवस्थापन.<br />
    • कायदेशीर नोटीस/प्रतिसाद, जनजागृती, अद्ययावत कायदे/धोरणे कळवणे.<br />
    • ईमेल/एसएमएस/व्हॉट्सअॅपद्वारे सूचनाः न्यूजलेटर्स, कार्यक्रम माहिती, मोहिमा (तुमच्या संमतीवर आधारित; तुम्ही केव्हाही ऑप्टआउट करू शकता.)<br />
    • सुरक्षा, फसवणूक प्रतिबंध, लॉग/ऑडिट, कायदेशीर बंधनांचे पालन.<br />
    • वेबसाइट/सेवा सुधारण्यासाठी analytics.<br />
    काही प्रसंगी प्रक्रिया संमती (consent) वर, तर काही प्रसंगी कायद्यानुसार ‘legitimate use’ (कायदेशीर वापर) / वैध हेतू किंवा कायदेशीर बंधन या आधारांवर होऊ शकते.
    DPDP Act नुसार दिलेली संमती कधीही मागे घेण्याचा (withdraw) हक्क तुम्हाला आहे.
  </p>

  <h2>5. Cookies व तृतीयपक्षीय ट्रॅकिंग</h2>
  <p>
    आमच्या साइटवर आवश्यक (essential) आणि विश्लेषण (analytics) हेतूसाठी cookies वापरल्या जाऊ शकतात. आपण इच्छित असल्यास ब्राउझर सेटिंगमधून
    cookies नाकारू शकता; तथापि काही फिचर्स योग्यरित्या कार्य करणार नाहीत.
  </p>

  <h2>6. तुमचे अधिकार (Data Principal Rights)</h2>
  <ul>
    <li>माहिती मिळवण्याचा अधिकार — तुमची कोणती माहिती, कोणत्या हेतूने प्रक्रिया होते याची माहिती मागू शकता.</li>
    <li>दुरुस्ती, पूर्तता, अद्यतन आणि विलोपन (correction, completion, updating &amp; erasure) करण्याचा अधिकार.</li>
    <li>संमती मागे घेण्याचा अधिकार — दिलेली संमती कधीही मागे घेऊ शकता (withdraw).</li>
    <li>तक्रार निवारणाचा अधिकार (Grievance Redressal) — आमच्या Grievance Officer कडे तक्रार करू शकता; कायद्यानुसार ठरलेल्या कालमर्यादेत प्रतिसाद देणे आमची जबाबदारी आहे.</li>
    <li>Nominate करण्याचा अधिकार — आपल्या मृत्यू/असमर्थतेच्या प्रसंगी आपल्या वतीने हक्क बजावण्यासाठी एखाद्या व्यक्तीची नेमणूक करू शकता.</li>
  </ul>

  <h2>7. तक्रार निवारण (Grievance Redressal)</h2>
  <p>
    तुमच्या वैयक्तिक माहितीसंबंधित कुठलीही तक्रार/विनंती खालील Grievance Officer कडे नोंदवा. आम्ही कायद्यानुसार/नियमांनुसार ठरवलेल्या कालावधीत (नंतर नियम अधिसूचित झाल्यावर) तुमची तक्रार सोडवण्याचा प्रयत्न करू.<br /><br />
    Grievance Officer (डेटा संरक्षण अधिकारी / DPO):<br />
    (नाव भरा)<br />
    ईमेल: mlsamiti.sangli@lokadhikar.in<br />
    पत्ता: महाराष्ट्र लोकाधिकार समिती कार्यालय – हापूस होम्स, जामसंडे, ता. देवगड जि. सिंधुदुर्ग, देवगड – 416 613<br />
    फोन: 7887779899
  </p>

  <h2>8. डेटा शेअरिंग / तृतीयपक्ष</h2>
  <ul>
    <li>पेमेंट गेटवे, ईमेल/एसएमएस सेवा प्रदाते, क्लाउड/होस्टिंग, अॅनालिटिक्स, सोशल मीडिया प्लॅटफॉर्म यांच्याशी आवश्यक तेवढाच डेटा शेअर केला जाऊ शकतो.</li>
    <li>कायद्यानुसार आवश्यक असल्यास (न्यायालय, कायदा अंमलबजावणी संस्था इ.) आम्ही माहिती प्रदान करू शकतो.</li>
    <li>आम्ही कोणताही अनधिकृत/अनावश्यक विक्री/व्यापारीकरण करीत नाही.</li>
  </ul>

  <h2>9. आंतरराष्ट्रीय डेटा ट्रान्सफर</h2>
  <p>
    जर आमचे सर्व्हर्स/साधने भारताबाहेर असतील किंवा तृतीयपक्ष सेवा प्रदात्यांचे सर्व्हर भारताबाहेर असतील, तर तुमची माहिती सीमापार (crossborder) हस्तांतरित होऊ शकते. अशावेळी आम्ही कायद्याने परवानगी दिलेल्या चौकटीत आवश्यक सुरक्षा मानदंडांचे पालन करू.
  </p>

  <h2>10. संग्रह व जतन कालावधी (Retention)</h2>
  <p>
    निर्धारित हेतू पूर्ण होईपर्यंत, किंवा कायद्याने आवश्यक असेपर्यंतच तुमची माहिती जतन केली जाईल. हेतू संपल्यानंतर/संमती मागे घेतल्यानंतर आम्ही ती माहिती सुरक्षितपणे विलोपित/अनामित करू (जेथे कायदेशीर बंधन नाही).
  </p>

  <h2>11. सुरक्षा उपाय (Security)</h2>
  <p>
    आम्ही तांत्रिक आणि संघटनात्मक (organisational) पातळीवर वाजवी सुरक्षा उपाय (एन्क्रिप्शन, अॅक्सेस कंट्रोल, लॉगिंग, बॅकअप इ.) वापरतो. परंतु इंटरनेटवरील 100% सुरक्षा हमी देणे शक्य नाही.
  </p>

  <h2>12. अल्पवयीन (Children)</h2>
  <p>
    १८ वर्षांखालील व्यक्तींबाबत, शक्य तेथे पालक/संरक्षकाची संमती घेण्याचा आमचा प्रयत्न असेल. (DPDP Act अंतर्गत “किशोर डेटा” संबंधित विशेष बंधने/नियम अधिसूचित झाल्यास त्यांचे पालन केले जाईल.)
  </p>

  <h2>13. Consent Manager</h2>
  <p>
    जेव्हा शासकीय नियम/फ्रेमवर्क पूर्णपणे अधिसूचित होतील, तेव्हा कायद्यानुसार लागू असल्यास आम्ही Consent Manager द्वारे तुमच्या संमतीचे व्यवस्थापन करण्याची सोय उपलब्ध करू.
  </p>

  <h2>14. तृतीयपक्ष दुवे (External Links)</h2>
  <p>
    आमच्या साइटवर इतर वेबसाइट्स/सोशल मीडिया प्लॅटफॉर्मचे दुवे असू शकतात. त्या प्लॅटफॉर्मवरील गोपनीयता पद्धतींसाठी आम्ही जबाबदार नाही. कृपया त्यांची धोरणे स्वतंत्रपणे वाचा.
  </p>

  <h2>15. या धोरणातील बदल</h2>
  <p>
    हे धोरण वेळोवेळी बदलू शकते. बदलल्यास “Last updated” तारीख अद्ययावत केली जाईल आणि गरजेनुसार तुम्हाला सूचित केले जाईल.
  </p>
</div>

       
 <footer className="pir-footer">
    <div className="footer-container">
      {/* Logo on the left */}
      <div className="footer-left">
        <img src="/web.png" alt="Logo" className="footer-logo-vertical" />
      </div>

      {/* Center: Two columns of links */}
      <div className="footer-center">
        <div className="footer-links-columns">
          <ul className="footer-links">
            <li>
              <a href="/privacypolicy">
                <FontAwesomeIcon icon={faLock} /> गोपनीयता धोरण <span>(Privacy Policy)</span>
              </a>
            </li>
            <li>
              <a href="/signuppolicy">
                <FontAwesomeIcon icon={faFileSignature} /> नोंदणी धोरण <span>(Signup Policy)</span>
              </a>
            </li>
          </ul>
          <ul className="footer-links">
            <li>
              <a href="/termsuse">
                <FontAwesomeIcon icon={faFileContract} /> वापर अटी <span>(Terms of Use)</span>
              </a>
            </li>
            <li>
              <a href="/disclaimer">
                <FontAwesomeIcon icon={faExclamationTriangle} /> अस्वीकृती <span>(Disclaimer)</span>
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Right: Social links */}
      <div className="footer-right">
      <div className="footer-social">
                            <a href="https://x.com/Lokadhikar2005?t=n-S1KS-Ao-aj7fmOe-QRxw&s=09"  target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faXTwitter} /></a>
                            <a href="https://www.facebook.com/groups/2151387758675095/?ref=share&mibextid=NSMWBT" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                           <a href="https://www.linkedin.com/in/lokadhikar-samiti-0537a937a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                            <a href="https://www.instagram.com/lokadhikar.in?igsh=ZXN0bHpiYm5nMjg=" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://youtube.com/@lokadhikar-2005?si=cuc0vPRI6NLxhaQs" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} /></a>
                          </div>
      </div>
      
      
    </div>

    

    {/* Right side fixed icons */}


    {/* Bottom text */}
  <div className="footer-bottom">
    <p className="marathi-text">
      © २०२५ महाराष्ट्र लोकाधिकार समिती – <span className="blue-tex">सर्व हक्क राखीव</span>
    </p>
  </div>

  </footer>
<ul className="right-side-icons">
    <li>
          <a href="/" className="icon-link pulse-glow" title="Home">
            <FontAwesomeIcon icon={faHome} />
          </a>
        </li>
        <li>
         <a href="tel:+917887779899" className="icon pulse-glow" title="Call Us">
            <FontAwesomeIcon icon={faPhone} />
          </a>
        </li>
       
      </ul>

    </>
  );
};

export default PrivacyPolicy;
